export function getImageSize(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = (err) => {
      reject(err || new Error('Failed to load image'));
    };
    img.crossOrigin = 'anonymous';
    img.src = url;
  });
}

export function loadImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err || new Error('Failed to load image'));
    img.crossOrigin = 'anonymous';
    img.src = url;
  });
}

export function cropImage({ src, x, y, width, height, outputWidth, outputHeight }) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = outputWidth || width;
      canvas.height = outputHeight || height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        img,
        x,
        y,
        width,
        height,
        0,
        0,
        canvas.width,
        canvas.height
      );
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = (err) => reject(err || new Error('Failed to crop image'));
    img.crossOrigin = 'anonymous';
    img.src = src;
  });
}
